module.exports = __webpack_public_path__ + "static/media/Light Grey.e652db05.jpg";